import { Cart, Discount, Order } from '../cart';
import { WithSDKError } from '../shared';
import {
  CreatePayPalOrderPayload,
  CreatePayPalOrderResponse,
  ValidatePayPalCheckoutPayload,
} from './PayPal';
import { ValidateStripeCheckoutPayload, StripePaymentResponse } from './Stripe';

export {
  type CreatePayPalOrderPayload,
  type CreatePayPalOrderResponse,
  type ValidatePayPalCheckoutPayload,
};

export { type ValidateStripeCheckoutPayload, type StripePaymentResponse };

export type CartResponse = WithSDKError<Cart>;

export type PrepareCartPayload = {
  discountCode?: string;
  variant: { skus: string[]; legacySkus: string[] };
};

export type PrepareCartForProgramPayload = {
  programId: string;
  discountCode?: string;
  legacySkus: string[];
};

export type PrepareCartResponse = WithSDKError<{
  discountErrorCode?: AlertCode;
  cart: Cart;
}>;

export type RedeemDiscountPayload = {
  cartID: string;
  code: string;
  skus: string[];
};

export type RedeemDiscountResponse = WithSDKError<{
  code: string;
  cart: Cart;
}>;

export type RemoveDiscountPayload = {
  cartID: string;
  discount: Discount;
};

export type RemoveDiscountResponse = WithSDKError<{
  cart: Cart;
}>;

export type ClearCartResponse = WithSDKError<{
  cart: Cart;
}>;

export type PriceDetails = {
  lineItemsTotalPrice?: number;
  cartTotal?: number;
  currencyCode?: string;
  fractionDigits?: number;
  cartDiscount: {
    discount?: Discount;
    amount?: number;
    percent?: string;
  };
  discountInDollars: number;
  lineItemsTaxed: {
    amount: {
      centAmount: number;
    };
    grossAmount: {
      centAmount: number;
    };
  };
};

export enum AlertCode {
  CART_CHANGED = 'cart_changed',
  CART_LOAD_FAILED = 'cart_load_failed',
  FALLBACK = 'fallback',
  FALLBACK_WITH_RELOAD_INFORMATION = 'fallback_with_reload_information',
  INVALID_COUPON = 'invalid_coupon',
  PAYMENT_PROCESSING_FAILED = 'payment_processing_failed',
  ORDER_PROCESSING_FAILED = 'order_processing_failed',
  PRODUCT_NOT_FOUND = 'product_not_found',
  // For now this use only for legacy redirection and not for error alert
  // but in future there will be alert against it
  PRODUCT_ENTITLEMENTS_ENROLLEMENT_FETCH_ERROR = 'product_entitlements_enrollment_fetch_error',
  PRODUCT_CREDIT_ELIGIBILITY_ERROR = 'product_credit_eligibility_error',
  PRODUCT_UNAVAILABLE = 'product_unavailable',
  PRODUCT_UNAVAILABLE_TO_BUY = 'product_unavailable_to_buy',
  ORDER_ALREADY_PLACED = 'order_already_placed',
  REDEEM_DISCOUNT = 'redeem_discount',
  REMOVE_DISCOUNT = 'remove_discount',
  SKU_NOT_PROVIDED = 'sku_not_provided',
  TRANSACTION_DECLINED = 'transaction_declined',
  PAYPAL_PAYMENT_PROCESSING_FAILED = 'paypal_payment_processing_failed',
  PAYPAL_TRANSACTION_CANCELLED = 'paypal_transaction_cancelled',
  COUPON_NOT_ELIGIBLE_FOR_CART = 'coupon_not_eligible_for_cart',
  COUPON_NOT_VALID_FOR_CART = 'coupon_not_valid_for_cart',
  COUPON_NOT_ELIGIBLE_FOR_BUNDLED_PURCHASE = 'coupon_not_eligible_for_bundled_purchase',
  DISCOUNT_CODE_EXPIRED = 'discount_code_expired',
  UNKNOWN_ERROR = 'order_processing_failed',
  DISCOUNT_CODE_NOT_PROVIDED = 'discount_code_not_provided',
  DISCOUNT_NOT_FOUND = 'discount_not_found',
}

export enum PSP {
  STRIPE = 'stripe',
  PAYPAL = 'paypal',
}

export enum UNKNOWN_PSP {
  Type = 'Unknown',
}
export const UNDEFINED_COUNTRY = 'UNDEFINED';

export type ValidateCheckoutResponse = WithSDKError<{
  ctPaymentID: string;
  payerName: string;
}>;

export type ProcessCheckoutPayload = {
  ctPaymentID: string;
  cartID: string;
  payerName: string;
};

export type ProcessCheckoutResponse = WithSDKError<{
  order: Order | null;
}>;
